import { render, staticRenderFns } from "./WorkoutStep.vue?vue&type=template&id=898410ec&scoped=true"
import script from "./WorkoutStep.vue?vue&type=script&lang=js"
export * from "./WorkoutStep.vue?vue&type=script&lang=js"
import style0 from "./WorkoutStep.vue?vue&type=style&index=0&id=898410ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898410ec",
  null
  
)

export default component.exports